import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import First from "./Landingpage/First";
import Privacy from "./Landingpage/privacy_policy";
import Termscondition from "./Landingpage/Terms&condition";
import Faq from "./Landingpage/Faq";
import Pricing from "./Landingpage/Pricing";
import Contactus from "./Landingpage/Contact";
import ContactForm from "./Landingpage/Invite";
import Blog from "./Landingpage/Blog";
import Article from "./Landingpage/Article";
import Author from "./Landingpage/Author";
import ChatWidget from "./Landingpage/ChatBot";
import Competitiveresearch from "./Landingpage/Competitiveresearch";
import Domainoverview from "./Landingpage/Domainoverview";
import Keywordgap from "./Landingpage/Keywordgap";
import Onpageseo from "./Landingpage/Onpageseo";
import Seoaudit from "./Landingpage/Seoauditpage";
import Page from "./Landingpage/Page";
import Structure from "./Landingpage/Structure";
import Internallink from "./Landingpage/Internallink";
import Sitemappage from "./Landingpage/Sitemappage";
import Sociallinks from "./Landingpage/Sociallink";
import Robot from "./Landingpage/Robot";
import Domainage from "./Landingpage/Domainage";
import Linkbuilding from "./Landingpage/Linkbuilding";
import Serp from "./Landingpage/Serp";
import Keywordresearch from "./Landingpage/Keywrodresearch";
import Linkingdomain from "./Landingpage/Linkingdomain";
import Googletrend from "./Landingpage/Googletrend";
import Trendingnow from "./Landingpage/Trendingnow";
import Trendingovertime from "./Landingpage/Interestovertime";
import Toppages from "./Landingpage/Toppages";
import Risingtopic from "./Landingpage/Risingtopic";
import Urlinspect from "./Landingpage/Url";
import Keywordbuilder from "./Landingpage/Keybuilder";
import Magictool from "./Landingpage/Magictool";
import Connectus from "./Landingpage/Connect";
import Inspectnow from "./Landingpage/Inspect";

function App() {
  return (
    <Router>
      <Routes>
        {/* Define your routes here */}
        <Route path="/" element={<First />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/terms-and-Conditions" element={<Termscondition />} />
        <Route path="/pricing-plans" element={<Pricing />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/contact-us" element={<Connectus />} />
        <Route path="/invite-us" element={<ContactForm />} />
        <Route path="/Blog" element={<Blog />} />
        <Route path="/blog/:post_slug" element={<Article />} />
        <Route path="/author/:post_slug" element={<Author />} />
        <Route path="/ChatWidget" element={<ChatWidget />} />
        <Route path="/Sitereport" element={<Inspectnow />} />
        <Route path="/master-keyword-research-like-a-pro-with-our-keyword-magic-tool" element={<Magictool />} />
        <Route path="/construct-your-seo-success-with-keyword-builder" element={<Keywordbuilder />} />
        <Route path="/best-url-inspection-tool" element={<Urlinspect />} />
        <Route
          path="/track-the-top-performing-pages-of-website"
          element={<Toppages />}
        />
        <Route
          path="/boost-google-ranking-with-keyword-interest"
          element={<Trendingovertime />}
        />
        <Route path="/trending-now-on-google" element={<Trendingnow />} />
        <Route
          path="/seo-link-building-dashboard"
          element={<Linkingdomain />}
        />
        <Route
          path="/increase-google-ranking-with-trending-topics"
          element={<Risingtopic />}
        />
        <Route path="/free-google-trends-tool" element={<Googletrend />} />
        <Route
          path="/best-keyword-research-tool-in-india-2025"
          element={<Keywordresearch />}
        />
        <Route path="/meta-description-preview-generator" element={<Serp />} />
        <Route
          path="/help-google-crawlers-manage-website"
          element={<Robot />}
        />
        <Route
          path="/transform-your-content-with-google-structured-data-for-better-search-results"
          element={<Structure />}
        />
        <Route
          path="/boost-your-seo-with-smart-internal-linking-strategies"
          element={<Internallink />}
        />
        <Route
          path="/generate-your-perfect-sitemap-in-seconds-with-our-seobix-tool"
          element={<Sitemappage />}
        />
        <Route
          path="/boost-your-social-media-with-the-best-social-links-generator"
          element={<Sociallinks />}
        />

        <Route
          path="/one-click-to-every-page-and-your-ultimate-site-seo-is-ready"
          element={<Page />}
        />
        <Route
          path="/run-a-free-seo-audit-and-uncover-hidden-ranking-issues"
          element={<Seoaudit />}
        />
        <Route
          path="/competitive-research-with-seobix-understand-your-competitors-strategies"
          element={<Competitiveresearch />}
        />
        <Route
          path="/domain-overview-tool-examine-your-website-authority-in-just-one-click"
          element={<Domainoverview />}
        />
        <Route
          path="/discover-your-competitors-keywords-to-boost-your-rankings-with-seobix"
          element={<Keywordgap />}
        />
        <Route
          path="/best-free-on-page-seo-tool-for-high-google-rankings"
          element={<Onpageseo />}
        />
        <Route
          path="/domain-age-checker-track-website-journey"
          element={<Domainage />}
        />
        <Route
          path="/tracks-and-records-every-backlink-in-one-place"
          element={<Linkbuilding />}
        />
      </Routes>
    </Router>
  );
}

export default App;
